import React from 'react';
import clx from 'classnames';
import { ContainerFront } from '../../ContainerFront';
import { Col, Row, Space, Typography } from 'antd';
const { Title, Text, Paragraph } = Typography;

import { Link } from 'react-router-dom';
import './MicFooterFront.scss';
import { useThemeConfig } from 'client/components/schema/config/ClientConfigModule';
import { Trans, useTranslation } from 'react-i18next';
import { MicFooterFrontPolicyRow } from './MicFooterFrontPolicyRow';

export interface MicFooterFrontProps {
  className?: string;
}

/**
 * Container del Footer delle pagine pubbliche
 * Definisce la larghezza massima del contenuto della pagina.
 */
export function MicFooterFront(props: MicFooterFrontProps) {
  const { t } = useTranslation();
  const spans = { sm: 24, md: 8 };

  return (
    <ContainerFront
      isFooter
      className={clx('footer-front-mic', props.className)}
    >
      <Row className="istitutional-row">
        <Col {...spans}>
          <a href=" https://cultura.gov.it/" target="_blank">
            <div className="logo-mic" />
          </a>
        </Col>
        <Col {...spans}>
          <Space direction="vertical" size="middle">
            <p>
              <strong>
                {t('mic:footer.address-title', 'Sede centrale MiC')}
              </strong>
            </p>
            <div>
              <Trans t={t} i18nKey="mic:footer.address">
                <p>Via del Collegio Romano, 27</p>
                <p>00186 Roma</p>
                <p>Centralino: (+39) 06.6723.1</p>
              </Trans>
            </div>
          </Space>
        </Col>
        <Col {...spans}>
          <Space direction="vertical" size="middle">
            <p>
              <strong>
                {t(
                  'mic:footer.transparent-administration-label',
                  'Amministrazione Trasparente'
                )}
              </strong>
            </p>
            <a href="https://cultura.gov.it/numero-verde" target="_blank">
              <div className="numero-verde-min"></div>
            </a>
          </Space>
        </Col>
      </Row>
      <MicFooterFrontPolicyRow showTopLine />
    </ContainerFront>
  );
}
